import styled from 'styled-components';
import { Box } from '@/shared/ui/box/Box';


const DescriptionSection = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export { DescriptionSection }